import { createAction } from '@gef-ui/utils/fsaActions';
import { actionTypes } from '../constants';
/**
 * Reports an error
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(reportError({status: 401, message: 'error', errorCode: 'unauthorized', stackTrace: undefined}));
 *
 */ export const reportError = createAction(actionTypes.REPORT_ERROR);
/**
 * Dismiss an error
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(dismissError());
 *
 */ export const dismissError = createAction(actionTypes.DISMISS_ERROR);
export default {
    reportError,
    dismissError
};
